import liff from '@line/liff'
import { LineLinkService } from '@/services'

export default {
  computed: {
    notRequiredAddFriend() {
      return !this.$store.state.auth.shop?.ec_line_required_flag
    },
    isWeb() {
      return this.liffIdExists && liff.getOS() === 'web'
    },
    isRequiredLine() {
      return this.$store.state.auth.shop?.ec_line_required_flag || false
    },
    isShowButtonLine() {
      return this.notRequiredAddFriend && !this.friendship && !this.isWeb && !!this.liffIdExists
    },
  },

  methods: {
    async checkFriendShip() {
      if (!this.liffIdExists || this.isRequiredLine) {
        this.friendship = false
      } else {
        if (this.user) {
          if (!this.user.line_id) {
            this.friendship = false
          } else {
            const { data } = await LineLinkService.checkFriendLine(this.user.line_id)
            const notAddStatus = [this.Constants.FRIEND_STATUS.PERMISSION, this.Constants.FRIEND_STATUS.NOT_ADD]
            this.friendship = !notAddStatus.includes(data.friend_status_id)
          }
        } else {
          if (!liff.isLoggedIn()) {
            this.friendship = false
          } else {
            const { friendFlag } = await liff.getFriendship()
            this.friendship = friendFlag
          }
        }
      }
    },
  },
}
